import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customText' })
export class CustomTextPipe implements PipeTransform {
	transform(value: any, args: string[]): any {
		var transformed = value;
		if (!value) {
			transformed = '';
		} else {
			value = value.replace(/_/g, " ");
			transformed = value.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase()));
		}

		if (transformed.toLowerCase() == "us") {
			transformed = "US"
		}

		return transformed;
	}
}
